import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { ErrorComponent } from 'src/components/error/error.component';
import { DocuSignCallbackComponent } from 'src/components/docu-sign-callback/docu-sign-callback.component';
import { BranchFundingPageComponent } from 'src/components/funding-page/branch-funding-page/branch-funding-page.component';

const routes: Routes = [
  {
    path: '', loadChildren: () => import('./applicant-loan/applicant-loan.module').then(m => m.ApplicantLoanModule),
  },
  {
    path: 'branch-funding', component: BranchFundingPageComponent
  },
  {
    path: 'error-page', component: ErrorComponent,
  },
  {
    path: 'docu-sign-callback', component: DocuSignCallbackComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})

export class AppRoutingModule { }
